var $ = require('jquery');

var $Mask,
    $ActiveAboveMaskElements;

function createMask() {
    return $('<div>')
        .addClass('ws-site-mask');
}

exports.showDesktopNavMask = function () {
    if ($Mask) {
        $Mask.remove();
    }

    $Mask = createMask()
        .addClass('ws-site-mask--desktop-mega-menu')
        .prependTo($('body'));
}

exports.showMask = function ($aboveMaskElements, $dialog) {
    var $container = typeof $dialog !== 'undefined' && $dialog instanceof $ && $dialog.length > 0
        ? $dialog
        : $('body');

    $ActiveAboveMaskElements = $aboveMaskElements;
            
    if ($Mask) {
        $Mask.remove();
    }

    $Mask = createMask().prependTo($container);

    if ($aboveMaskElements) {
        $aboveMaskElements.css({ 'z-index': 9999 });
    }
}

exports.hide = function () {
    if ($Mask) {
        $Mask.remove();
    }

    if ($ActiveAboveMaskElements) {
        $ActiveAboveMaskElements.css({ 'z-index': '' });
    }
}